export const FORMAT = "L";
export const LOCALE = "pl";



// WEBPACK FOOTER //
// ./src/providers/MomentProvider.js